import { bl_inv_stock_replenishment_run_filter_location_RowClass } from '../../../dbschema/bl_inv_stock_replenishment_run_filter_location.model';
import { BaseContainerModel } from '../../base-container.model';


export class StockReplenishmentRunFilterLocationModel extends BaseContainerModel {
  bl_inv_stock_replenishment_run_location: bl_inv_stock_replenishment_run_filter_location_RowClass = new bl_inv_stock_replenishment_run_filter_location_RowClass();
}
